const constants =
{
    loaderPrefix: 'ONDURO.loader.',
}

export default constants;


// WEBPACK FOOTER //
// ./src/js/constants.js